// Times as the console writes them: the CLI's remaining-time format (D-002),
// clock times and days in the viewer's own locale and time zone.

const minute = 60_000

/** The time left, rounded to the minute once a minute or more is left, as `purlview list` writes it. */
export function remaining(ms: number): string {
  if (ms <= 0) return '0s'
  let d = ms >= minute ? Math.round(ms / minute) * minute : Math.round(ms / 1000) * 1000
  const h = Math.floor(d / 3_600_000)
  d -= h * 3_600_000
  const m = Math.floor(d / minute)
  d -= m * minute
  const s = Math.floor(d / 1000)
  let out = ''
  if (h > 0) out += `${h}h`
  if (m > 0) out += `${m}m`
  if (s > 0 && h === 0) out += `${s}s`
  return out || '0s'
}

export function clock(t: Date, locale?: string): string {
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }).format(t)
}

/** "Sep 19", with the year when it is not this one. */
export function day(t: Date, now: Date, locale?: string): string {
  const sameYear = t.getFullYear() === now.getFullYear()
  return new Intl.DateTimeFormat(locale, sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' }).format(t)
}

export function sameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
}

/** "today", or the day. */
export function lastUsed(t: Date, now: Date, today: string, locale?: string): string {
  return sameDay(t, now) ? today : day(t, now, locale)
}
